<template>
  <base-section
    id="visa"
  >
      <base-section-heading title="Visa">
        ETS23 takes place in Venice, Italy. Participants from some countries shall require a VISA to enter Italy/Europe boundaries; the ETS23 Organizing Committee suggests you get aware of the VISA process required for your country as soon as you plan to attend the event. The emission of a VISA may take from weeks to months depending on the procedure related to your country. If you need assistance preparing the documentation for your VISA to access Italy, please contact the VISA Chair Nima Kolahimahmoudi at nima dot kolahimahmoudi at polito dot it (<a href="mailto:nima.kolahimahmoudi@studenti.polito.it">nima.kolahimahmoudi@studenti.polito.it</a>)
    </base-section-heading>
<br>
      <br>
        <v-footer
          id="regional-footer"
          color="primary"
          dark
          min-height="72"
          class="hidden-md-and-up"
        >
          <v-container>
            <v-row>
              <v-col
                cols="12"
                md="6"
              >
                <div class="d-flex flex-wrap justify-md-start justify-center justify-md-none">
                  <template v-for="(s, i) in venuefooter">
                    <router-link
                      :key="s.name"
                      class="white--text pa-1 pa-md-0"
                      :to="s.url"
                      v-text="s.name"
                    />

                    <v-responsive
                      v-if="i < venuefooter.length - 1"
                      :key="`divider-${s.name}`"
                      class="mx-4 shrink hidden-sm-and-down"
                      max-height="24"
                    >
                      <v-divider vertical />
                    </v-responsive>
                  </template>
                </div>
              </v-col>
            </v-row>
          </v-container>
        </v-footer>
  </base-section>
</template>
<script>
  export default {
    data () {
      return {
        isMobile: false,
        venuefooter: [
          {
            name: 'City of Venice',
            url: 'venice',
          },
          {
            name: 'Congress Center',
            url: 'congress-center',
          },
          {
            name: 'Hotel Rooms',
            url: 'hotel-rooms',
          },
          {
            name: 'Visa',
            url: 'visa',
          },
        ],
      }
    },
    mounted () {
      this.isMobile = (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
    },
    methods: {
      isMobileDevice () {
        return (typeof window.orientation !== 'undefined') || (navigator.userAgent.indexOf('IEMobile') !== -1)
      },
    },
  }
</script>
